import React, { useState, useEffect } from 'react';
import carouselStyle from '../Components/Carousel.module.css'; 

const Carousel = ({ onImageChanges }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = ['/Images/S1.webP', '/Images/S2.webP', '/Images/S3.webP', '/Images/S4.webP'];
    const colors = ['#E9DCC9', '#FFFDD0', '#C19A6B', '#333d29'];

    // Notify parent component of color changes when the image changes
    useEffect(() => {
        if (onImageChanges) {
            onImageChanges(colors[currentIndex]);
        }
    }, [currentIndex, onImageChanges]);

    // Automatically change the slide every 2 seconds (2000ms)
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000); // Adjusted time to 2 seconds
        return () => clearInterval(interval);
    }, [images.length]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    return (
        <div className={carouselStyle.carousel}>
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`${carouselStyle.carouselImage} ${index === currentIndex ? carouselStyle.active : ''}`}
                    style={{ backgroundImage: `url(${image})` }}
                />
            ))}
            <button className={carouselStyle.prev} onClick={handlePrev}>‹</button>
            <button className={carouselStyle.next} onClick={handleNext}>›</button>
        </div>
    );
};

export default Carousel;
